// extracted by mini-css-extract-plugin
export default {"moduleNotesContainer":"PrimeNoteList_moduleNotesContainer__EqgAp","noteItemList":"PrimeNoteList_noteItemList__qr3CP"};